<!-- Download Indicator -->
<div *ngIf="mailService.loading">
	<div class="spinner-overlay"></div>
	<div class="spinner-content">
		<app-spinner></app-spinner>
	</div>
</div>

<div class="full-height slate task-inbox">
	<div class="main-flex">
		<!-- Header -->
		<app-page-header id="mail-outbox-header" [iconId]="396">
			{{ pageTitle }}
		</app-page-header>

		<!-- Container -->
		<div class="main-container">
			<!-- Left Side -->
			<div class="left-side">
				<!-- Loading Indicator for Outboxes -->
				<app-spinner *ngIf="loading"></app-spinner>

				<!-- Mail Outbox Menu-->
				<app-menu
					[menuConfig]="mailConsoleMenuConfig"
					[allowLabelToggle]="false"
					(menuItemClicked)="getPreparedBatches($event)"
					*ngIf="!loading"
				></app-menu>
			</div>

			<!-- Right Side -->
			<div class="right-side">
				<app-spinner *ngIf="loading"></app-spinner>
				<!-- Search Control -->
				<app-search #mailConsoleSearch [showCriteria]="false" [allowMultipleSelect]="true" *ngIf="!loading">
					<!-- Mail Console Action Buttons -->
					<div class="action-buttons">
						<button
							*ngIf="showApprove"
							[disabled]="mailConsoleSearch?.searchState.selectedRows.selected.length == 0 || loading"
							id="approve-mail-batches"
							mat-raised-button
							color="primary"
							class="action-button"
							(click)="markMailBatchesApproved()"
						>
							<fa-icon [icon]="$any(['fass', 'check'])" style="margin-right: 8px !important"></fa-icon>
							Approve
						</button>
						<button
							*ngIf="showMarkSubcontracted"
							[disabled]="mailConsoleSearch?.searchState.selectedRows.selected.length == 0 || loading"
							id="subcontract-mail-batches"
							mat-raised-button
							color="accent"
							class="action-button"
							(click)="markMailBatchesSubcontracted()"
						>
							Subcontract
						</button>
						<button
							*ngIf="showMarkPrinted"
							[disabled]="mailConsoleSearch?.searchState.selectedRows.selected.length == 0 || loading"
							id="print-mail-batches"
							mat-raised-button
							color="accent"
							class="action-button"
							(click)="markMailBatchesPrinted()"
						>
							Mark Printed
						</button>
						<button
							*ngIf="showMarkSent"
							[disabled]="mailConsoleSearch?.searchState.selectedRows.selected.length == 0 || loading"
							id="send-mail-batches"
							mat-raised-button
							color="accent"
							class="action-button"
							(click)="markMailBatchesSent()"
						>
							Mark Sent
						</button>
						<button
							*ngIf="showEditBatchNotes"
							[disabled]="mailConsoleSearch?.searchState.selectedRows.selected.length == 0 || loading"
							id="edit-batch-notes"
							mat-raised-button
							color="accent"
							class="action-button"
							(click)="editBatchNotes()"
						>
							Add/Edit Notes
						</button>
						<button
							*ngIf="showEditBatch"
							[disabled]="mailConsoleSearch?.searchState.selectedRows.selected.length == 0 || loading"
							id="edit-mail-batches"
							mat-raised-button
							color="accent"
							class="action-button"
							(click)="editBatch()"
						>
							Edit Batch
						</button>
						<button
							*appPermissionId="1103"
							[disabled]="mailConsoleSearch?.searchState.selectedRows.selected.length == 0 || loading"
							id="discard-mail-batches"
							mat-raised-button
							color="accent"
							class="action-button"
							(click)="unprepareMailBatches()"
						>
							Discard
						</button>
					</div>
				</app-search>
			</div>
		</div>
	</div>
</div>
